import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    throwError as observableThrowError,
    Observable,
    BehaviorSubject,
    throwError,
} from 'rxjs';
import { catchError, last } from 'rxjs/operators';
import { Response } from '@angular/http';

@Injectable({
    providedIn: 'root',
})
export class KycService {
    constructor(
        private http: HttpClient,
        @Inject('baseUrl') private baseUrl: string
    ) {}

    //get users profile
    getProfile() {
        return this.http
            .get(this.baseUrl + `/users/profile`)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    //get User Wallet and Virtual Account
    getWallet(id){
        return this.http
        .get(this.baseUrl + `/wallets/user/`+id)
        .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    updateKYC(data: FormData) {
        let productType ="ADVISORY"
        return this.http
            .put(this.baseUrl + `/users/onboard?productType=`+productType, data)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    createAccount(firstname: string, lastname:string, productType:string) {
        const data = {
            firstName: firstname,
            lastName:lastname,
            productType:productType
        };
        return this.http
            .put(this.baseUrl + `/users/onboard?productType=`+productType, data)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }
    updateImageKYC(data: FormData) {
        return this.http
            .post(this.baseUrl + `/uploads`, data)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    onboard(firstname: string, lastname:string, productType:string) {
        const data = {
            firstName: firstname,
            lastName:lastname,
            productType:productType
        };
        return this.http
            .post(this.baseUrl + `/users/onboard?productType=`+productType, data)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    checkBvn(bvn: number) {
        const data = {
            bvn: bvn,
        };
        return this.http
            .post(this.baseUrl + `/kyc/user/bvn`, data)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    sendOtp(phone: string) {
        const data = {
            phone: phone,
        };
        return this.http
            .post(this.baseUrl + `/kyc/user/phone/validate`, data)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    getVirtualAccount(id:string){
        return this.http
        .get(this.baseUrl + `/vaccounts/wallet/` + id)
        .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    getBank(){
        return this.http
        .get(this.baseUrl + `/banks`)
        .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }
    

    validateOtp(otp) {
        const data = {
            otp: otp,
        };
        return this.http
            .post(this.baseUrl + `/kyc/user/phone/authenticate-otp`, data)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    getUserKycStatus(id) {
        return this.http
            .get(this.baseUrl + `/kyc/user/` + id)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    getUserWalletTransaction(){
        return this.http
        .get(this.baseUrl + `/wallets/transactions`)
        .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    updateAccountInfo(bankAcctName:string, bankAcctNo:string,bankId: string,) {
        const data = {
            bankAcctName:bankAcctName,
            bankAcctNo:bankAcctNo,
            bankId: bankId
        };
        return this.http
            .put(this.baseUrl + `/users/account-details?productType=ADVISORY`, data)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

}
